import React, { Component } from 'react';

// Externals
import axios from 'axios';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
// Material helpers
import { withStyles } from '@material-ui/core';
import { withRouter } from "react-router-dom";
// Material components
import { Grid } from '@material-ui/core';

// Shared layouts
import { Application as ApplicationLayout } from 'layouts';
import AddContact from "./contacts/AddContact";
import Avatar from "./contacts/Avatar";
// Material table
import MaterialTable from 'material-table'

// Material Kit
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
// import Button from "components/CustomButtons/Button.jsx";

// Auth
// import AuthHelperMethods from 'components/Auth/AuthHelperMethods.jsx';
import withAuth from 'components/Auth/withAuth.jsx';

// import { cardTitleWhite, cardCategoryWhite } from "assets/jss/material-kit-pro-react.jsx";

// Component styles
const styles = theme => ({
  root: {
    padding: theme.spacing.unit * 4
  },
  item: {
    height: '100%'
  },
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF"
    }
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1"
    }
  }
});

class ContactsTab extends Component {



  constructor(props) {
    super(props);
    this.state = {
      AddContactModal: false,
      Updated: false
    };
  }

  handleClickOpen(modal) {
    var x = [];
    x[modal] = true;
    this.setState(x);
  }

  handleClose(modal) {
    var x = [];
    x[modal] = false;
    this.setState(x);
  }


  handleClickDelete(lead) {

    const { confirm } = this.props;
    window.confirm("You want to delete lead ref:" + lead);

    let url = `${process.env.REACT_APP_API_URL}leads/` + lead + '.json';
    axios
      .delete(url,{headers:{ Authorization: 'Bearer ' + confirm }})
      .then(response => {
        window.alert("Deleted!");
        this.setState({ Updated: true });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  render() {
    const { classes } = this.props;
    const { confirm } = this.props;
    const { profile } = this.props;
    const { tableRef } = React.createRef();

    return (

        <div className={classes.root}>
          <Grid
            container
            spacing={8}
          >


            <Grid
              item
              lg={12}
              sm={12}
              xl={12}
              xs={12}
            >


                  <MaterialTable
                    tableRef={tableRef}
                  columns={[
                    { title: 'Avatar', field: 'attributes.avatar', editable: "onRowAdd",
                      render: rowData => <Avatar uri={rowData.attributes.avatar} id={rowData.attributes.id}/>},
                      // <img src={ rowData.attributes.avatar == null ? "foo" : rowData.attributes.avatar } style={{width: 40, borderRadius: '50%'}} alt="avatar" /> },
                    // { title: 'Id', field: 'id' },
                    { title: 'Name', field: 'attributes.first_name' },
                    { title: 'Surname', field: 'attributes.last_name' },
                    { title: 'Phone', field: 'attributes.phone_number' },
                    { title: 'Email', field: 'attributes.email' },
                    { title: 'Address', field: 'attributes.full_address' },
                    { title: 'Campaign', field: 'attributes.full_address' },
                    { title: 'Active', field: 'attributes.active', type: 'boolean' }

                  ]}
                  data={profile.attributes.contacts}
                  title="Contacts"
                  options={{
                    grouping: true,
                    search: true,
                    filtering: true,
                    exportButton: true,
                    actionsColumnIndex: 0
                  }}
                  actions={[
                              {
                                icon: 'forward',
                                tooltip: 'go to contact profile',
                                onClick: (event, rowData) => this.props.history.push('/contacts/' + rowData.attributes.id )
                              },

                              {
                                icon: 'add',
                                tooltip: 'Add contact',
                                isFreeAction: true,
                                onClick: (event) => this.handleClickOpen("AddContactModal")
                              }
                            ]}
                  editable={{

                    onRowUpdate: (newData, oldData) =>
                      new Promise((resolve, reject) => {
                        setTimeout(() => {


                          resolve();
                        }, 1000)
                      }),
                    onRowDelete: oldData =>
                      new Promise((resolve, reject) => {

                        setTimeout(() => {
                          const { confirm } = this.props;
                          let url = `${process.env.REACT_APP_API_URL}leads/` + oldData.id + '.json';
                          axios
                            .delete(url,{headers:{ Authorization: 'Bearer ' + confirm }})
                            .then(response => {
                              this.setState({ Updated: true });
                            })
                            .catch((error) => {
                              console.log(error);
                            });

                          resolve()
                        }, 1000)
                      }),
                  }}

                />

            </Grid>

          </Grid>
            <AddContact confirm={this.props.confirm} handleClose={this.handleClose.bind(this)} isOpen={this.state.AddContactModal}/>
        </div>


    );
  }
}

ContactsTab.propTypes = {
  classes: PropTypes.object.isRequired
};

export default compose(
  withStyles(styles),
  withRouter
)(ContactsTab);
